import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GoogleAnalyticsGA4Service } from './google-analytics-ga4.service';

@NgModule({
  imports: [CommonModule],
  providers: [GoogleAnalyticsGA4Service],
})
export class GoogleAnalyticsGA4Module {}
